import { render, staticRenderFns } from "./YearGroupDetail.vue?vue&type=template&id=5423b362&scoped=true"
import script from "./YearGroupDetail.vue?vue&type=script&lang=js"
export * from "./YearGroupDetail.vue?vue&type=script&lang=js"
import style0 from "./YearGroupDetail.vue?vue&type=style&index=0&id=5423b362&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5423b362",
  null
  
)

export default component.exports